import { useTranslation } from "@/i18n/useTranslation";
import { useConfigStore } from "@/store";
import { formatTitle } from "@/utils";
import styles from "./StepTitleDescription.module.css";
import { useTb } from "@/hooks/useTb";
import Button from "../UI/Button";

interface StepTitleDescriptionProps {
  title: string;
  description?: string;
  variant?: "default" | "howToReadModal";
  loginDescription?: string;
  loginButtonText?: string;
  loginAvailable?: boolean;
  login?: () => void;
}

export const StepTitleDescription: React.FC<StepTitleDescriptionProps> = ({
  title,
  description,
  variant = "default",
  loginDescription,
  loginButtonText,
  loginAvailable = false,
  login,
}) => {
  const { t } = useTranslation();
  const { config } = useConfigStore();
  const tb = useTb();

  // Format title and description to replace ###MISSING_EYE### placeholder
  const formattedTitle = formatTitle(t(title), config?.contactLensesData, t);

  const isMobile =
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 576px)").matches
      : false;

  const isHowToRead = variant === "howToReadModal";
  const contentClass = isHowToRead ? styles.contentHowToRead : styles.content;
  const titleClass = isHowToRead
    ? isMobile
      ? styles.titleHowToReadMobile
      : styles.title
    : isMobile
      ? styles.titleMobile
      : styles.title;

  return (
    <div className={contentClass}>
      <h2 className={titleClass}>{formattedTitle}</h2>
      {loginAvailable && (
        <div className={styles.login}>
          {loginDescription}
          <Button variant="link" onClick={login}>
            {loginButtonText}
          </Button>
        </div>
      )}
      {description && <p className={styles.description}>{tb(description)}</p>}
    </div>
  );
};
